import {
  Users,
  Bookmark,
  ChevronLeft,
  Share2,
  PencilLine,
  Bell,
  Heart,
  Table2,
  X,
} from 'lucide-react';

// lucide 기반 래퍼 — 기존 API(size, filled, ...props)를 그대로 유지한다.
export const IconUsers = ({ size = 14, ...p }) => (
  <Users size={size} strokeWidth={2.5} {...p} />
);

export const IconBookmark = ({ size = 14, filled = false, ...p }) => (
  <Bookmark size={size} strokeWidth={2} fill={filled ? 'currentColor' : 'none'} {...p} />
);

export const IconBack = ({ size = 18, ...p }) => (
  <ChevronLeft size={size} strokeWidth={2.5} {...p} />
);

export const IconShare = ({ size = 16, ...p }) => (
  <Share2 size={size} strokeWidth={2} {...p} />
);

export const IconBlog = ({ size = 10, ...p }) => (
  <PencilLine size={size} strokeWidth={2.5} {...p} />
);

// 브랜드 아이콘은 lucide v1에서 제거되어 커스텀 SVG로 유지한다.
export const IconInsta = ({ size = 10, ...p }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <rect x="2" y="2" width="20" height="20" rx="5"/>
    <circle cx="12" cy="12" r="5"/>
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor"/>
  </svg>
);

export const IconYoutube = ({ size = 10, ...p }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 001.46 6.42 29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.4a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58z"/>
    <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="currentColor" stroke="none"/>
  </svg>
);

export const IconNaver = ({ size = 10, ...p }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M3 3h7l4 6V3h7v18h-7l-4-6v6H3z"/>
  </svg>
);

export const IconBell = ({ size = 13, ...p }) => (
  <Bell size={size} strokeWidth={2.5} {...p} />
);

export const IconHeart = ({ size = 13, ...p }) => (
  <Heart size={size} strokeWidth={2.5} {...p} />
);

export const IconTable = ({ size = 13, ...p }) => (
  <Table2 size={size} strokeWidth={2.5} {...p} />
);

export const IconX = ({ size = 14, ...p }) => (
  <X size={size} strokeWidth={2.5} {...p} />
);

export const CHANNEL_MAP = {
  // 정적 데이터 (소문자)
  blog:      { label: '블로그', Icon: IconBlog,    className: 'ch-badge--blog' },
  insta:     { label: '인스타', Icon: IconInsta,   className: 'ch-badge--insta' },
  youtube:   { label: '유튜브', Icon: IconYoutube, className: 'ch-badge--youtube' },
  naver:     { label: '네이버', Icon: IconNaver,   className: 'ch-badge--naver' },
  // API 타입 (대문자)
  BLOG:      { label: '블로그', Icon: IconBlog,    className: 'ch-badge--blog' },
  INSTAGRAM: { label: '인스타', Icon: IconInsta,   className: 'ch-badge--insta' },
  YOUTUBE:   { label: '유튜브', Icon: IconYoutube, className: 'ch-badge--youtube' },
  OTHER:     { label: '기타',   Icon: IconNaver,   className: 'ch-badge--naver' },
};
